export const HOMEPAGE_REFRESH_EVENT = 'homepage-refresh';

/** Anasayfadayken logo / ana sayfa linkine basılınca ürün listesini yenile. */
export function requestHomepageRefresh() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(HOMEPAGE_REFRESH_EVENT));
}

export function isExactHomepagePath(pathname, locale) {
  if (!pathname) return false;
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (normalized === '/') return true;
  const code = String(locale || '').substring(0, 2);
  return Boolean(code) && normalized === `/${code}`;
}

/**
 * Ana sayfa şerit / hizmet kartları için site_settings listeleri.
 * Boş veya eksik liste: tüm öğeler varsayılan olarak açık.
 */
export function isHomePageItemEnabled(items, id, defaultWhenMissing = true) {
  if (!items || !Array.isArray(items) || items.length === 0) return defaultWhenMissing;
  const row = items.find((x) => x && x.id === id);
  if (!row) return defaultWhenMissing;
  return row.enabled !== false;
}

/**
 * Admin: canonical meta sırasına göre, kayıtta olan sıra ve enabled ile birleştirir (yeni id'ler sona eklenir).
 */
export function mergeQuickStripListForAdmin(meta, stored) {
  const metaIds = new Set((meta || []).map((m) => m?.id).filter(Boolean));
  const seen = new Set();
  const out = [];
  for (const row of stored || []) {
    if (row?.id && metaIds.has(row.id) && !seen.has(row.id)) {
      out.push({ id: row.id, enabled: row.enabled !== false });
      seen.add(row.id);
    }
  }
  for (const { id } of meta || []) {
    if (id && !seen.has(id)) {
      out.push({ id, enabled: true });
      seen.add(id);
    }
  }
  return out;
}

/**
 * Ana sayfa şeridi: filtreden sonra, kayıtta sıra listesi doluysa bu sıraya göre sıralar; eksik öğeler sonda kalır.
 */
export function sortQuickStripDisplayOrder(displayList, orderItems) {
  if (!orderItems || !Array.isArray(orderItems) || orderItems.length === 0) {
    return displayList || [];
  }
  if (!displayList || displayList.length === 0) return [];
  const byId = new Map(displayList.map((c) => [c.id, c]));
  const seen = new Set();
  const out = [];
  for (const row of orderItems) {
    const c = row?.id ? byId.get(row.id) : null;
    if (c && !seen.has(c.id)) {
      out.push(c);
      seen.add(c.id);
    }
  }
  for (const c of displayList) {
    if (!seen.has(c.id)) out.push(c);
  }
  return out;
}
